import React, { Component } from 'react';
import "./Playbuzz.scss"
import ScrollableAnchor from 'react-scrollable-anchor'
import { push } from "../../Services/Analytics"
import Footer from '../../Footer/Footer';
import Readmore from './Readmore/Readmore';
import PlaybuzzPopup from '../../Helpers/Popup/PlaybuzzPopup';
import { setScrollNaming } from '../../Services/ScrollURL';

class Playbuzz extends Component {
  constructor(props) {
    super();
    this.clickedToPlay = this.clickedToPlay.bind(this);
    this.state = {
      showPlayBuzz: false
    }
  }
  componentDidMount() {
    setScrollNaming(this.section);
  }
  clickedToPlay() {
    push("Playbuzz_clicked", "");
    this.props.togglePopup(<PlaybuzzPopup />, "PlaybuzzPopup");
    // this.setState({
    //   showPlayBuzz: !this.state.showPlayBuzz
    // })
  }
  render() {
    return (
      <section className={`section section-playbuzz ${this.state.showPlayBuzz ? " active" : ""}`} ref={section => this.section = section}>
        <div className="padding">
          <div className="container">
            <div className="headline">
              <div className="head">
                עד כמה אתם מחוברים לרגשות שלכם?
                      </div>
              <div className="desc">
                רוצו על שאלון החוויות שלנו וגלו לאיזה מחנה אתם משתייכים בדרך כלל: של אלה שהכול כתוב להם על הפנים, או של ההם שמצליחים להיות קפואים ומרוסנים
                      </div>
            </div>
            <div className="poster" onClick={this.clickedToPlay} style={{ display: (this.state.showPlayBuzz ? "none" : "block") }}>
              <div className="image">
                <div className="button">
                  <div className="text">
                    בואו נתחיל!
                           </div>
                </div>
              </div>
            </div>
            {/* <div className="game" style={{ display: (this.state.showPlayBuzz ? "block" : "none") }}>
                <div className="playbuzz" data-id="15003862-c8a6-4c95-bc1f-09e99dabe616" data-show-share="false" data-show-info="false"></div>
              </div> */}
          </div>
        </div>
        <Readmore 
        teaserText="לרכישת המכשיר בחנויות המורשות"
        togglePopup={this.props.togglePopup} />
        <Footer />
      </section>
    );
  }
}




export default Playbuzz;



// WEBPACK FOOTER //
// ./src/Components/Screens/5_Playbuzz/Playbuzz.jsx